import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { getListadoSimulaciones, verSimulacionOpe } from '../api/apiConfig';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdVisibility } from 'react-icons/md';

const ListadoSimulacion = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const handleVerSimulacion = async (id) => {
    try {
      const response = await verSimulacionOpe(id);
      let simulacionData = response;
      if (response && response.body && typeof response.body === 'string') {
        simulacionData = JSON.parse(response.body);
      }
      
      navigate('/resultado-simulacion', {
        state: { simulacionData, idCotizacion: id }
      });
    } catch (error) {
      console.error('Error al obtener simulación:', error);
      alert('Error al cargar la simulación');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      
      try {
        setLoading(true);
        const response = await getListadoSimulaciones(user);
        let parsedData = response;
        if (response && response.body && typeof response.body === 'string') {
          parsedData = JSON.parse(response.body);
        }
        setData(parsedData || []);
      } catch (err) {
        setError('Error al cargar los datos');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL');
  };

  const formatCurrency = (value) => {
    if (!value) return '$0';
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(value);
  };

  if (loading) {
    return (
      <div className="panel-container">
        <div className="panel-header">
          <h1 className="panel-title">Listado de Simulaciones</h1>
        </div>
        <div className="flex justify-center items-center h-32">
          <AiOutlineLoading3Quarters className="animate-spin h-8 w-8" style={{color: 'var(--if-primary)'}} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="flex items-baseline gap-4 mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Listado de Simulaciones</h1>
        </div>
        <div className="text-center py-8" style={{color: 'var(--if-text-muted)'}}>
          {error}
        </div>
      </div>
    );
  }

  return (
      <div className="p-6">
        <div className="flex items-baseline gap-4 mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Listado de Simulaciones</h1>
      </div>

      <div className="seccion-datos">
        {data.length === 0 ? (
          <div className="text-center py-8" style={{color: 'var(--if-text-muted)'}}>
            No hay simulaciones disponibles
          </div>
        ) : (
          <div className="tabla-container" style={{maxHeight: '500px', overflowY: 'auto', overflowX: 'auto'}}>
            <table style={{fontSize: '0.875rem', tableLayout: 'fixed', width: '100%'}}>
              <thead style={{position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10}}>
                <tr>
                  <th style={{width: '80px'}}>ID</th>
                  <th style={{width: '250px'}}>Cliente</th>
                  <th style={{width: '120px'}}>RUT</th>
                  <th style={{width: '150px'}}>Ejecutivo</th>
                  <th style={{width: '150px'}}>Equipo</th>
                  <th style={{width: '120px'}}>Fecha Simulación</th>
                  <th style={{width: '100px', textAlign: 'center'}}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.NOMBRE_CLIENTE}</td>
                    <td>{item.RUT_CLIENTE}</td>
                    <td>{item.EJECUTIVO}</td>
                    <td>{item.EQUIPO}</td>
                    <td>{formatDate(item.FECHA_SIMULACION)}</td>
                    <td style={{textAlign: 'center'}}>
                      <button
                        onClick={() => handleVerSimulacion(item.id)}
                        className="btn-primary"
                        style={{
                          padding: '0.25rem 0.75rem',
                          fontSize: '0.75rem',
                          borderRadius: '4px',
                          width: '32px',
                          height: '32px'
                        }}
                        title="Ver simulación"
                      >
                        <MdVisibility className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListadoSimulacion;